import styled from 'styled-components';
import FlexBox from '../../components/FlexBox';
import Container from '../../components/Container';
import CountDown from './component/CountDown';

export const ContainerMax = styled(Container)`
  @media (min-width: 768px) {
    max-width: 970px;
  }
  @media (min-width: 992px) {
    max-width: 970px;
  }
  @media (min-width: 1260px) {
    max-width: ${({ theme }) => theme.maxWidth};
  }
`;

export const BannerBox = styled(FlexBox)`
  width: 100%;
  padding: 0 4%;
  height: 500px;
  background: #171C21 url(${require('./images/vote.banner.png')}) no-repeat center/cover;
  text-align: center;
  color: #fff;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  
  h2 {
    height: 3.3em;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-family: ${({ theme }) => theme.fontIBMLight};
    font-weight: 300;
    font-size: 48px;
    line-height: 60px;
    margin-bottom: 15px;
  }

  .subTitle {
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-weight: 300;
    display: flex;
    justify-content: center;
    font-size: 24px;
    line-height: 34px;
    height: 3em;
  }

  .desc {
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    opacity: 0.5;
  }

  @media screen and (max-width: 414px) {
    height: 360px;
    h2 {
      height: 3.7em;
      font-size: 28px;
      line-height: 36px;
    }
    .subTitle {
      font-size: 16px;
      line-height: 22px;
    }
    
    .desc {
      font-size: 14px;
      line-height: 16px;
    }
  }
`;

export const DayCountDown = styled(CountDown)`
`;

export const VoteWrapper = styled.div`
  margin-top: -78px;
  margin-bottom: 30px;
  
  .bnb-info {
    display: flex;
    color: #212833;
    font-size: 18px;
    align-items: center;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    
    > i {
      width: 24px;
      height: 24px;
      flex: none;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 100px;
      margin-right: 6px;
    }
  }
  
  @media screen and (max-width: 414px) {
    margin: -87px 16px 16px;
  }
`;

export const VoteContent = styled.div`
  padding: 32px 170px;
  min-height: 100px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  background: #fff;
  
  .vote-tips {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-bottom: 40px;
    flex-wrap: wrap;
    
    > span {
      display: flex;
      align-items: center;
      margin-right: 20px;
      
      > b { margin: 0 3px; }
      
      > i { margin-left: 3px; }
    }
    > a { color: #F0B90B; }
  }
  
  .vote-title {
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    background: url(${require('./images/vs.png')}) no-repeat center/auto 75%;
    
    .bnb-info {
      > span {
        font-size: 16px;
        line-height: 21px;
        color: #848E9C;
        margin: 0 5px;
        font-family: ${({ theme }) => theme.fontIBMRegular};
      }
    }
  }
  
  .vote-progress {
    display: flex;
    justify-content: space-between;
    border-radius: 100px;
    height: 24px;
    align-items: center;
    overflow: hidden;
    margin: 20px 3px 10px;
    
    &[data-empty=true] {
      background: #EAECEF;
      
      > span { display: none; }
    }
    
    > span {
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      color: #fff;
      position: relative;
      overflow: hidden;
      min-width: 6.5em;
      padding: 0 18px;

      &:nth-child(1) {
        background: linear-gradient(270deg, #3E87F3 7.43%, #3769F9 100%);
        
        &::after {
          content: '';
          width: 8px;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          transform: skewX(-20deg) translateX(4px);
          background: #fff;
        }
      }
      
      &:nth-child(2){
        text-align: right;
        background: linear-gradient(90deg, #F06728 -7.32%, #ED4727 100%);
        
        &::before {
          content: '';
          width: 8px;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          transform: skewX(-20deg) translateX(-4px);
          background: #fff;
        }
      }
    }
  }
  
  .vote-btns {
    padding: 30px 0 16px;
    display: flex;
    justify-content: space-between;
  }
  
  @media screen and (min-width: 414px) {
    .vote-title {
      .bnb-info {
        font-size: 26px;
        
        > i {
          width: 40px;
          height: 40px;
          margin-right: 11px;
        }
      }
    }
  }
  
  
  @media screen and (max-width: 992px) {
    padding: 24px 60px;
  }
  
  @media screen and (max-width: 414px) {
    padding: 24px 16px;
    
    .vote-tips {
      margin-bottom: 20px;
      font-size: 14px;
      
      > span { margin-right: 4px; }
    }
    
    .vote-title {
      .bnb-info {
         > span {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
`;

export const Introduce = styled(FlexBox)`
  background: #fff;
  border: 1px solid #EAECEF;
  border-radius: 3px;
  margin: 20px auto;
  padding: 32px 0 28px;
  
  > article {
    flex: 1;
    border-right: 1px solid #EAECEF;
    padding: 0 32px;
    font-size: 16px;
    
    &:last-of-type {
      border-right: 0;
    }
    
    .desc {
      margin: 20px 0 11px;
      line-height: 28px;
      color: #848E9C;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp:2;
    }
    
    .foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      > a { color: #F0B90B; }
      
      .a-list {
        > a  {
          width: 26px;
          height: 26px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #D8D8D8;
          border-radius: 100px;
          margin-left: 10px;
          
          &:hover {
            background: rgba(132, 142, 156, 0.8);
          }
        }
      }
    }
  }
  
  @media screen and (min-width: 414px) {
    > article {
      .bnb-info {
        font-size: 20px;
        
        > i {
          width: 30px;
          height: 30px;
          margin-right: 11px;
        }
      }
    }
  }
  
  @media screen and (max-width: 414px) {
    flex-wrap: wrap;
    padding: 0 16px;
    
    > article {
      width: 100%;
      flex: none;
      border-right: none;
      padding: 32px 0;
      border-bottom: 1px solid #EAECEF;
      
      &:last-of-type {
        border-bottom: 0;
      }
      
      .desc {
        -webkit-line-clamp:4;
      }
    }
  }
`;

export const TableFlex = styled(FlexBox)`
  margin-top: 58px;
  
  @media screen and (max-width: 414px) {
    flex-wrap: wrap;
    margin-top: -18px;
  }
`;

export const CoinConfirm = styled.div`
  text-align: left;
  
  
  .icon-err {
    width: 104px;
    height: 104px;
    margin: 0 auto 30px;
    display: block;
    background: url(${require('./images/icon.info.png')}) no-repeat center/100%;
  }
  
  h4.tle { 
    text-align: center;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 12px;
  }
  
  p.desc {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 0;
  }

  .bnb-info {
    display: flex;
    color: #48515D;
    font-size: 18px;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    
    > i {
      width: 34px;
      height: 34px;
      flex: none;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 100px;
      margin-right: 6px;
    }
  }
  
  .c-tips {
    margin-top: 5px;
  
    > b { margin: 0 4px; }
    
    > span { color: #999; }
  }
`;

export const Terms = styled.div.attrs(() => ({
  id: 'rule-term',
}))`
  padding: 60px 4%;
  margin: 40px 0 10px;
  background: rgba(234,236,239,0.3);
  ul {
    list-style-type: none;
    margin-bottom: 32px;
  }
  strong {
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: #48515D;
    display: inline-block;
    margin-bottom: 6px;
  }
  li, p {
    font-size: 14px;
    line-height: 22px;
    color: #848E9C;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  @media screen and (max-width: 414px) {
    padding: 40px 4%;
  }
`;
